import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { active as _active } from 'd3'

interface searchKeyI {
  key: string
  imgFile: any
  imgsList: any
  searchData: searchDataI
  isLoading: boolean
}

const initialState: searchKeyI = {
  key: '',
  imgFile: {},
  imgsList: {},
  searchData: {
    keyword: '',
    criteria: [],
    pages: {
      page: 1,
      size: 14
    }
  },
  isLoading: false
}

export interface searchDataI {
  keyword: string
  criteria: { key: string; value: string[] }[]
  pages: { page: number; size: number }
}

export const setSearchKeySlice = createSlice({
  name: 'setSearchKey',
  initialState,
  reducers: {
    setSearchKey: (state, action: PayloadAction<string>) => {
      state.key = action.payload
    },
    setImgFile: (state, action: PayloadAction<any>) => {
      state.imgFile = action.payload
    },
    setImgsList: (state, action: PayloadAction<any>) => {
      state.imgsList = action.payload
    },
    setSearchData: (state, action: PayloadAction<searchDataI>) => {
      state.searchData = action.payload
    },
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    }
  }
})
export const { setSearchKey, setImgFile, setImgsList, setSearchData, setIsLoading } =
  setSearchKeySlice.actions
export default setSearchKeySlice.reducer
